import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { EditaTabelaDeFretesModalComponent } from '../modals/edita-tabela-de-fretes-modal/edita-tabela-de-fretes-modal.component';
import { ImportarTabelaDeFretesModalComponent } from '../modals/importar-tabela-de-fretes-modal/importar-tabela-de-fretes-modal.component';
import { Filtro } from '../models/filtro';
import { Frete } from '../models/frete';
import { Ibge } from '../models/ibge';
import { ArquivoService } from '../services/arquivo.service';
import { CarregandoService } from '../services/carregando.service';
import { FreteService } from '../services/frete.service';
import { IbgeService } from '../services/ibge.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { TransportadoraModalComponent } from '../modals/transportadora-modal/transportadora-modal.component';
import { TransportadoraService } from '../services/transportadora.service';
import { Transportadora } from '../models/transportadora';
import swal from 'sweetalert2';
import { FaixaFreteService } from '../services/faixa-frete.service';
import { FornecedorService } from '../services/fornecedor.service';
import { PremissasService } from '../services/premissas.service';
import { PaginatorService } from '../services/paginator.service';
import { ExportarFretesMultiCDsModalComponent } from '../modals/exportar-fretes-multi-cds-modal/exportar-fretes-multi-cds-modal.component';
import { ModalidadeComponent } from '../modalidade/modalidade.component';
import { ModalidadeService } from '../services/modalidade.service';
import { Modalidade } from '../models/modalidade';
import { PremissasSistema } from '../models/premissas-sistema';

declare const $: any;

@Component({
  selector: 'app-tabela-de-fretes',
  templateUrl: './tabela-de-fretes.component.html',
  styleUrls: ['./tabela-de-fretes.component.scss']
})
export class TabelaDeFretesComponent implements OnInit {
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;
  valorMinimo: number;
  carregando = true;
  taxaRural: number;
  campoOrdenacao = 'nome';
  ordenarDesc = false;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  estados = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
    'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];
  estadoSelecionado = undefined;
  cidadesFiltradas: Ibge[] = [];
  fretesFiltrados: Frete[] = [];
  cidadeSelecionado = undefined;
  transportadoras: Transportadora[] = [];
  transportadoraSelecionada = undefined;
  faixas = [];
  usarCentroDeDistribuicao = false;
  usarMultiFornecedores = false;
  fornecedores = [];
  cdSelecionado;

  modalidades: Modalidade[] = [];
  modalidadeSelecionada;

  premissasSistema: PremissasSistema;

  constructor(
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService,
    public dialog: MatDialog,
    private freteService: FreteService,
    private transportadoraService: TransportadoraService,
    private faixaFreteService: FaixaFreteService,
    private fornecedorService: FornecedorService,
    private premissasService: PremissasService,
    private paginatorService: PaginatorService,
    private modalidadeService: ModalidadeService
  ) { }

  async ngOnInit() {
    await this.buscarPremissasSistema();

    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarTransportadoras();

    if (this.premissasSistema.usarModalidade) {
      this.buscarModalidadesExistentes();
    }

    this.buscarFaixas();
    this.buscarFornecedores();
    this.buscarPremissaCentroDeDistribuicao();
    this.buscarPremissaMultFornecedor();
  }

  buscarModalidadesExistentes(tipo: number = 0) {
    if (!this.premissasSistema.usarModalidade) {
      return;
    }

    const idTransp = this.transportadoraSelecionada !== null && this.transportadoraSelecionada !== undefined && this.transportadoraSelecionada !== "-1" ? this.transportadoraSelecionada : null;

    this.carregandoService.mostra('buscarModalidades');

    this.modalidadeService.listarModalidadesExistentes(idTransp).subscribe(data => {
      this.modalidades = data;
      this.modalidadeSelecionada = this.modalidades.length > 0 ? this.modalidades[0].id : null;
      // const mod = new Modalidade();
      // mod.id = -1;
      // mod.descricao = 'SEM MODALIDADE';

      // if (!this.modalidades.some(m => m.id === mod.id)) {
      //   this.modalidades.unshift(mod);
      // }

      // if (!this.modalidadeSelecionada || !this.modalidades.some(m => m.id === this.modalidadeSelecionada)) {
      //   this.modalidadeSelecionada = mod.id;
      // }
      if (tipo === 1)
      this.filtra(1);

      this.carregandoService.esconde('buscarModalidades');
    }, (erro) => {
      this.carregandoService.esconde('buscarModalidades');
      this.notificacaoService.erro('Não foi possível buscar as modalidades!');
    });
  }

  buscarPremissaMultFornecedor() {
    this.carregandoService.mostra('buscarPremissaMultFornecedor');
    this.premissasService.consultarMultiFornecedores().subscribe(
      data => {
        this.carregandoService.esconde('buscarPremissaMultFornecedor');
        if (data.valor) {
          this.usarMultiFornecedores = true;
          this.buscarFornecedores();
        }
      },
      err => {
        this.carregandoService.esconde('buscarPremissaMultFornecedor');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      centro => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        if (centro.valor) {
          this.usarCentroDeDistribuicao = true;
          this.buscarFornecedores();
        }
      },
      err => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscarFornecedores');
    this.fornecedorService.consultarFornecedores().subscribe(
      forn => {
        this.carregandoService.esconde('buscarFornecedores');
        this.fornecedores = forn;
      },
      err => {
        this.carregandoService.esconde('buscarFornecedores');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarTransportadoras() {
    this.carregandoService.mostra('buscarTransportadoras');

    this.transportadoraService.consultarTransportadoras().subscribe(dados => {
      this.transportadoras = dados;

      if (this.premissasSistema.usarModalidade) {
        const novaTransp = new Transportadora();
        novaTransp.id = "-1";
        novaTransp.nome = 'SEM TRANSPORTADORA';

        if (!this.transportadoras.some(transp => transp.id === novaTransp.id)) {
          this.transportadoras.unshift(novaTransp);
        }

        if (!this.transportadoraSelecionada) {
          this.transportadoraSelecionada = novaTransp.id;
        }
      }

      this.carregandoService.esconde('buscarTransportadoras');
    }, (erro) => {
      this.carregandoService.esconde('buscarTransportadoras');
    });
  }

  abrirModalTransportadora() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(TransportadoraModalComponent, {
      width: largura > 1024 ? '1000px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe(transportadoraSelecionada => {
      this.transportadoraSelecionada = transportadoraSelecionada.id;
    });
  }

  abrirModalModalidade() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(ModalidadeComponent, {
      width: largura > 1024 ? '1000px' : $('body').width().toString() + 'px',
      panelClass: 'modal-card',
    });
  }

  vincularTransportadoraCidades() {
    const transportadora = this.transportadoras.find(p => p.id === this.transportadoraSelecionada);

    swal({
      title: 'Atenção!!',
      html: 'Deseja realmente vincular a transportadora<br> <strong> ' + transportadora.nome + '</strong> a todas as cidades do estado <strong>' + this.estadoSelecionado + '</strong>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('vincularTransportadoraCidades');
        this.freteService.vincularTransportadora(this.estadoSelecionado, transportadora.id, this.cdSelecionado).subscribe(resp => {
          this.notificacaoService.sucesso('Vinculação feita com sucesso!!!');
          this.carregandoService.esconde('vincularTransportadoraCidades');
          this.transportadoraSelecionada = undefined;
          this.buscarFretes();
        }, (erro) => {
          this.carregandoService.esconde('vincularTransportadora');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  exportarPercentuais() {
    const largura = Number(($('body').width()));

    this.dialog.open(ExportarFretesMultiCDsModalComponent, {
      width: largura > 500 ? '750px' : (($('body').width()).toString() + 'px'),
      data: { cdSelecionado: this.cdSelecionado, idTransp: this.transportadoraSelecionada, idMod: this.modalidadeSelecionada, exibirModalidade: this.premissasSistema.usarModalidade },
      panelClass: 'modal-card'
    });
  }

  importarPercentuais() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ImportarTabelaDeFretesModalComponent, {
      width: largura > 800 ? '750px' : (($('body').width()).toString() + 'px'),
      data: { cdSelecionado: this.cdSelecionado, idTransp: this.transportadoraSelecionada, idMod: this.modalidadeSelecionada, percentuais: true, tipoOperacao: 1, exibirModalidade: this.premissasSistema.usarModalidade },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarFretes();
      }
    });
  }

  baixarArquivo() {
    this.carregandoService.mostra('baixarArquivo');
    this.freteService.baixarModelo().subscribe(arq => {
      this.utilitarioService.saveBlob(arq, 'TabelaDeFrete_Modelo.xlsx');
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  //tipoOperacao: 0 - exportarFrete | 1 - ImportarTabela
  exportarImportaFretes(tipoOperacao: number) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ImportarTabelaDeFretesModalComponent, {
      width: largura > 800 ? '750px' : (($('body').width()).toString() + 'px'),
      data: { cdSelecionado: this.cdSelecionado, tipoOperacao: tipoOperacao, idTransp: this.transportadoraSelecionada, idMod: this.modalidadeSelecionada, exibirModalidade: this.premissasSistema.usarModalidade },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.cdSelecionado = result.cd;
        this.transportadoraSelecionada = result.idTransp;

        this.buscarFretes();
      }
    });
  }

  buscarPercentualFaixaFrete(frete: Frete, idFaixa: number) {
    return frete.faixas.find(p => p.idFaixa === idFaixa).percentual;
  }

  buscarFretes() {
    if (!this.estadoSelecionado)
      return;

    this.carregandoService.mostra('buscarFretes');
    // this.transportadoraSelecionada = undefined;

    this.freteService.consultarComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.estadoSelecionado, this.cdSelecionado, this.transportadoraSelecionada, this.modalidadeSelecionada).subscribe(dados => {
        this.fretesFiltrados = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;

        this.carregandoService.esconde('buscarFretes');
      }, (erro) => {
        this.carregandoService.esconde('buscarFretes');
      });
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra(tipo: number = 0) {
    if (tipo === 1 && !this.premissasSistema.usarModalidade) {
      return;
    }

    this.buscarFretes();
    this.paginator.firstPage();
  }

  buscarFaixas() {
    this.carregandoService.mostra('buscarFaixas');
    this.faixaFreteService.consultarFaixas().subscribe(
      faixas => {
        this.carregandoService.esconde('buscarFaixas');
        this.faixas = faixas;
      },
      err => {
        this.carregandoService.esconde('buscarFaixas');
        this.notificacaoService.erro(err);
      }
    );
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFretes();
  }

  editar(frete) {
    const largura = Number(($('body').width()));
    const freteEditar = new Frete();
    Object.assign(freteEditar, frete);
    const dialogRef = this.dialog.open(EditaTabelaDeFretesModalComponent, {
      width: largura > 1050 ? '1000px' : (($('body').width()).toString() + 'px'),
      data: { frete: freteEditar, dados: this.fretesFiltrados, exibirModalidade: this.premissasSistema.usarModalidade },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarFretes();
      }
    });
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }
}
